module.exports = __webpack_public_path__ + "static/media/tech.cb221cbd.png";